export const MAPS_URL = 'https://www.google.com/maps/search/?api=1&query=Outpost+Custom+23+Lisle+Avenue+Kidderminster+DY11+7DF';

/** Outpost's Google Calendar appointment schedule (one page for in-person, phone and video). */
export const BOOKING_URL = 'https://calendar.app.google/B353MvcKKDNiJkS28';

/** Showroom and phone opening hours in 24h, Monday first. `null` = closed. */
export const HOURS: { day: string; short: string; open: [number, number] | null }[] = [
  { day: 'Monday', short: 'Mon', open: [10, 18] },
  { day: 'Tuesday', short: 'Tue', open: [10, 18] },
  { day: 'Wednesday', short: 'Wed', open: [10, 18] },
  { day: 'Thursday', short: 'Thu', open: [10, 18] },
  { day: 'Friday', short: 'Fri', open: [10, 16] },
  { day: 'Saturday', short: 'Sat', open: null },
  { day: 'Sunday', short: 'Sun', open: null },
];

export const fmtHour = (h: number) => (h === 12 ? '12pm' : h > 12 ? `${h - 12}pm` : `${h}am`);

/** Today's index into HOURS and whether we're open, in UK time whatever the visitor's zone. */
export function ukStatus(): { today: number; open: boolean; label: string } {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    weekday: 'short',
    hour: 'numeric',
    minute: 'numeric',
    hourCycle: 'h23',
  }).formatToParts(new Date());
  const get = (type: string) => parts.find((p) => p.type === type)?.value ?? '';
  const today = Math.max(0, HOURS.findIndex((h) => h.short === get('weekday')));
  const now = Number(get('hour')) + Number(get('minute')) / 60;
  const slot = HOURS[today].open;

  if (slot && now >= slot[0] && now < slot[1]) {
    return { today, open: true, label: `Open now · until ${fmtHour(slot[1])}` };
  }
  // Next opening: later today, or the next day with hours.
  if (slot && now < slot[0]) return { today, open: false, label: `Closed · opens ${fmtHour(slot[0])}` };
  for (let i = 1; i <= 7; i++) {
    const next = HOURS[(today + i) % 7];
    if (next.open) {
      const when = i === 1 ? 'tomorrow' : next.short;
      return { today, open: false, label: `Closed · opens ${when} ${fmtHour(next.open[0])}` };
    }
  }
  return { today, open: false, label: 'Closed' };
}
